module.exports = require("live/services/locale");